import {Funcionario} from "@/models/Funcionario";

export class User {
    constructor(
        public id: number = 0,
        public email: string = "",
        public alta: boolean = false,
        public funcionario_id = 0,

        public funcionario: Funcionario = new Funcionario()
    ) {
    }
}